var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"200%"}},[_vm._v("\n  El periodo de inscripción ha finalizado. ¡"),_c('b',[_vm._v("367")]),_vm._v(" inscripciones realizadas y "),_c('b',[_vm._v("592")]),_vm._v(" personas inscritas!\n  ")])
}]

export { render, staticRenderFns }